// extracted by mini-css-extract-plugin
module.exports = {"container":"page-title-bar_container__qU49v","title":"page-title-bar_title__3I8_N","backLink":"page-title-bar_backLink__Qw6Jv"};